module.exports = __webpack_public_path__ + "img/digital_5.0600cc85.png";